/**
 * Created by Chetan on 30-Jan-2020.
 */
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import Errors from '../common/Errors';
import Swal from 'sweetalert2'
import Select from 'react-select';
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
import * as AppConstant from '../common/AppConstant'



class DocTemplateUsers extends Component{

    constructor(props){
        super(props);
        this.state = {
            docTemplate : {
                
            },
            selectedUsers: [],
            loggedInUser:{},
            selectedUsersForSubmit: [],
            users: [],
            apiStatus: {
                isError: false,
                message: ''
            },
            disabledButton: false,
            showLoader:false,
            redirectToErrorPage:false
        }
        this.fetchDocTemplate = this.fetchDocTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.postDocTemplateUser = this.postDocTemplateUser.bind(this);
        this.fetchLoggedInStaff = this.fetchLoggedInStaff.bind(this);
    }

    componentDidMount(){
        this.fetchLoggedInStaff();
    }
    fetchLoggedInStaff(){
        let _this = this;
        fetch(this.props.api + '/staff/currentUser', {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    _this.props.onLogoutClick(json.message);
                }else{
                    if(json && json.staff && json.staff.userRoles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))){
                        _this.setState({loggedInUser: json.staff}, function(){
                            _this.fetchDocTemplate();
                        })
                    }else{
                        this.setState({redirectToErrorPage:true})
                    }
                }
                _this.setState({showLoader:false});
            }).catch(error => {
            console.log(error)
        });
    }
    handleChange(event) {
        console.log(event);
        let usersForSubmit = [];
        if(event){
            this.setState({selectedUsers: event});
            for (var i = 0, l = event.length; i < l; i++) {
                usersForSubmit.push({userId:event[i].value});
            }
            this.setState({selectedUsersForSubmit: usersForSubmit});
            console.log(usersForSubmit);
        }else{
            this.setState({selectedUsers: []});
        }
    }
    fetchDocTemplate(){
        this.setState({showLoader:true});
        var url = '/template/'+this.props.tid.id+'/users';
        fetch(this.props.api + url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
        .then(response => response.json())
        .then(json => {
            console.log(json);
            if (json !== undefined) {
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.setState({showLoader: false});
                    this.props.onLogoutClick(json.message);
                } else {
                    this.setState({docTemplate: json.docTemplate, users: json.users.content});
                    if(json.docTemplate && json.docTemplate.docTemplateUsers){
                        let usersMapped = [];
                        let usersMappedForSubmit = [];
                        for (var i = 0, l = json.docTemplate.docTemplateUsers.length; i < l; i++) {
                            usersMapped.push({value:''+json.docTemplate.docTemplateUsers[i].user.id, label:json.docTemplate.docTemplateUsers[i].user.firstName+" "+json.docTemplate.docTemplateUsers[i].user.lastName});
                            usersMappedForSubmit.push({userId:json.docTemplate.docTemplateUsers[i].user.id});
                        }
                        this.setState({selectedUsersForSubmit: usersMappedForSubmit,selectedUsers: usersMapped});
                    }
                    this.setState({showLoader: false});
                }
            }
        }).catch(error => {
            console.log(error);
            this.setState({showLoader:false});
        });
    }

    postDocTemplateUser(){
        this.setState({showLoader:true, disabledButton: true});
        var url = '/template/users';
        fetch(this.props.api + url, {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify({templateId: this.props.tid.id, users: this.state.selectedUsersForSubmit}),
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken,
                'content-type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json !== undefined) {
                    if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                        this.setState({showLoader: false, disabledButton: false});
                        this.props.onLogoutClick(json.message);
                    } else {
                        const {apiStatus}  = this.state;
                        if (json && json.isError === true) {
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                        }else{
                            Swal.fire("Success!", "Saved Successfully", "success");
                        }
                        this.setState({disabledButton: false, apiStatus: apiStatus, showLoader:false});
                    }
                }
            }).catch(error => {
            console.log(error);
            this.setState({showLoader:false, disabledButton: false});
        });
    }
    
    render() {
        let _this = this;
        var htmlTr = [];
        for (var i = 0, l = this.state.users.length; i < l; i++) {
            var cntains = validateValue(_this.state.users[i]);
            if (cntains === false)
                htmlTr.push({
                    value: this.state.users[i].id,
                    label: this.state.users[i].firstName + " " + this.state.users[i].lastName
                });
        }

        function validateValue(users){
            var cntains = _this.state.selectedUsers.some(v => {
                return (v.value === users.id+"")
            });
            return cntains
        }

        return (

            <div className="wrapper animated fadeInRight">

                <div className="row">
                    <div className="col-lg-12">
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">{this.state.docTemplate.templateName}</p><br/>
                                <h6><b>{this.state.docTemplate.description}</b></h6>
                                <h6><b>Created By {this.state.docTemplate.createdBy}&nbsp;
                                    on {moment(this.state.docTemplate.dateCreated).format(_this.props.organization.jsDateFormat)}</b>
                                </h6>
                            </div>
                            {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                            <div className="table-box table-responsive p-m" style={{minHeight:"410px"}}>
                                <InvalidAccessOrLogin jwtToken={this.props.jwtToken} redirectToErrorPage={this.state.redirectToErrorPage}/>
                                <Errors errorObject={this.state.apiStatus}/>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label htmlFor="">
                                                <h5>
                                                    <b>{_this.props.msg('docTemplate.users.enable')}</b>&nbsp;
                                                </h5>
                                            </label>
                                            <div className="col-lg-12">
                                                <Select
                                                    isMulti
                                                    name="users"
                                                    options={htmlTr}
                                                    className="basic-multi-select"
                                                    classNamePrefix="select"
                                                    onChange={this.handleChange}
                                                    placeholder="Select Users"
                                                    closeMenuOnSelect={false}
                                                    value={this.state.selectedUsers}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <div className="col-lg-12" style={{marginTop:"34px"}}>
                                                <Link to="/template/list" className="btn btn-white">{_this.props.msg('form.label.cancelButton')}</Link>&nbsp;&nbsp;&nbsp;
                                                <input className="btn btn-primary" type="button" value={_this.props.msg('form.label.submit')}
                                                       disabled={this.state.disabledButton===true} onClick={_this.postDocTemplateUser}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
export default DocTemplateUsers;


// WEBPACK FOOTER //
// ./src/components/template/DocTemplateUsers.js